import { useState } from 'react';
import { getConfig } from '@edx/frontend-platform';
import { useIntl } from '@edx/frontend-platform/i18n';

import messages from './messages';

export const useNewsletter = () => {
  const [email, setEmail] = useState<string>('');
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [newsletterNotif, setNewsletterNotif] = useState<{ success: boolean; msg: string }>({
    success: false,
    msg: '',
  });

  const intl = useIntl();

  const validateEmail = (emailAddress: string) => {
    // Updated regex pattern to validate email format with domain and extension
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // Additional check to ensure the domain part contains at least one dot
    const domainPart = emailAddress.split('@')[1];

    if (!domainPart || domainPart.split('.').length < 2) {
      return false;
    }

    return regex.test(emailAddress);
  };

  const submitToNewsletter = (emailAddress: string) => {
    if (!validateEmail(emailAddress)) {
      setNewsletterNotif({
        success: false,
        msg: intl.formatMessage(messages.newsletterInvalidEmail),
      });

      return;
    }
    setSubmitting(true);
    const url = `${getConfig().LMS_BASE_URL}/api/support/newsletter/subscribe/`;
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(intl.formatMessage(messages.newsletterFailedMessage));
        }
        if (response.ok) {
          setEmail('');
          setNewsletterNotif({
            success: true,
            msg: intl.formatMessage(messages.newsletterSuccessMessage),
          });
        }
      })
      .catch((err) => {
        setNewsletterNotif({
          success: false,
          msg: err.message,
        });
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return {
    newsletterNotif,
    submitToNewsletter,
    submitting,
    setEmail,
    email,
  };
};
